(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/teams-list-item.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/teams-list-item.js');
'use strict';

const Dots = svs.ui.ReactDots;
const {
  Card,
  CardBody,
  CardHeader
} = svs.ui.ReactCard;
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  InlineMessage
} = svs.components.tb_ui_react.inlineMessage;
const {
  ScrollToHash
} = svs.tb_ui_react.scroll_to_hash;

const ScrollOnReady = _ref => {
  let {
    hash
  } = _ref;
  const hasLoadedTeams = ReactRedux.useSelector(state => Object.keys(state.wagers).length === state.teams.teams.length);
  const location = ReactRouterDOM.useLocation();
  if (location.hash !== "#".concat(hash)) {
    return false;
  }
  return React.createElement(ScrollToHash, {
    hash: "".concat(hash),
    isReady: hasLoadedTeams
  });
};
const {
  ActiveMemberPanel,
  InactiveMemberPanel,
  LeaveTeamPopoverItem,
  MemberPopover,
  TeamBalance,
  TerminateTeamPopoverItem
} = svs.arena.pages.teams.components;
const TeamsListItem = _ref2 => {
  let {
    team
  } = _ref2;
  return React.createElement(React.Fragment, null, React.createElement(ScrollOnReady, {
    hash: team === null || team === void 0 ? void 0 : team.syndicateId
  }), React.createElement(Card, {
    branding: "tur",
    className: "margin-bottom-2"
  }, React.createElement(CardHeader, {
    className: "base-card-header"
  }, React.createElement("div", {
    className: "u-flex u-flex-align-items-center"
  }, React.createElement("div", {
    className: "col-xs-1"
  }), React.createElement("div", {
    className: "col-xs-10 f-center"
  }, React.createElement("h2", {
    className: "h2 margin-bottom margin-top-1"
  }, React.createElement("span", {
    className: "f-medium"
  }, team === null || team === void 0 ? void 0 : team.syndicateName))), React.createElement("div", {
    className: "col-xs-1 u-flex u-flex-justify-content-end"
  }, React.createElement(MemberPopover, null, (team === null || team === void 0 ? void 0 : team.isLeader) && React.createElement(TerminateTeamPopoverItem, {
    amount: team === null || team === void 0 ? void 0 : team.memberBalance,
    teamId: team.syndicateId,
    teamName: team === null || team === void 0 ? void 0 : team.syndicateName
  }, "Avsluta lag"), !(team !== null && team !== void 0 && team.isLeader) && React.createElement(LeaveTeamPopoverItem, {
    memberBalance: team === null || team === void 0 ? void 0 : team.memberBalance,
    teamId: team.syndicateId,
    teamName: team === null || team === void 0 ? void 0 : team.syndicateName
  }, "L\xE4mna lag"))))), React.createElement(Dots, {
    branding: "arena"
  }), React.createElement(CardBody, {
    className: "padding-h-0"
  }, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
    className: "align-center"
  }, (team === null || team === void 0 ? void 0 : team.tooFewMembers) && React.createElement("div", {
    className: "padding-h-1"
  }, React.createElement(InlineMessage, {
    icon: "players"
  }, "Laget beh\xF6ver ha minst 2 aktiva medlemmar f\xF6r att ni skall kunna spela.")), !(team !== null && team !== void 0 && team.tooFewMembers) && React.createElement(TeamBalance, {
    memberBalance: team === null || team === void 0 ? void 0 : team.memberBalance,
    playableAmount: team === null || team === void 0 ? void 0 : team.playableAmount
  }))), !(team !== null && team !== void 0 && team.isInactive) && React.createElement(ActiveMemberPanel, {
    team: team
  }), (team === null || team === void 0 ? void 0 : team.isInactive) && React.createElement(InactiveMemberPanel, {
    teamId: team === null || team === void 0 ? void 0 : team.syndicateId,
    teamName: team === null || team === void 0 ? void 0 : team.syndicateName
  })))));
};
svs.arena.pages.teams.components.TeamsListItem = TeamsListItem;

 })(window);